import {VisuallyHidden} from '@heroui/react'
import * as React from 'react'
import {cn} from 'utils/utils'
import {Drawer as DrawerPrimitive} from 'vaul'

const BarSoftDrawer = ({shouldScaleBackground = false, ...props}) => <DrawerPrimitive.Root shouldScaleBackground={false} modal={true} handleOnly={false} {...props} />
BarSoftDrawer.displayName = 'Drawer'
const NestedDrawer = ({shouldScaleBackground = false, ...props}) => <DrawerPrimitive.NestedRoot shouldScaleBackground={false} modal={true} handleOnly={false} {...props} />
NestedDrawer.displayName = 'NestedDrawer'
const BarSoftDrawerTrigger = DrawerPrimitive.Trigger

const BarSoftDrawerPortal = DrawerPrimitive.Portal

const BarSoftDrawerClose = DrawerPrimitive.Close
const BarSoftDrawerOverlay = React.forwardRef(({className, ...props}, ref) => <DrawerPrimitive.Overlay ref={ref} className={cn('absolute inset-0 z-10 select-auto bg-black/50 	', className)} {...props} />)
BarSoftDrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName

const BarSoftDrawerContent = React.forwardRef(({className, handleClassName, children, ...props}, ref) => (
	<BarSoftDrawerPortal aria-label='teszt'>
		<BarSoftDrawerOverlay />
		<VisuallyHidden>
			<DrawerPrimitive.Title>description goes here</DrawerPrimitive.Title>
			<DrawerPrimitive.Description>description goes here</DrawerPrimitive.Description>
		</VisuallyHidden>

		<DrawerPrimitive.Content ref={ref} className={cn('outline-none absolute w-full bottom-0 z-10 h-full !max-h-[90svh] overflow-hidden flex select-auto flex-col rounded-t-general bg-background', className)} {...props}>
			<div className={cn('mx-auto mt-4 h-2 w-[100px] z-10 top-0  overflow-visible left-0 right-0 shadow-xl shadow-white rounded-full bg-foreground/30 absolute', handleClassName)} />
			{children}
		</DrawerPrimitive.Content>
	</BarSoftDrawerPortal>
))
BarSoftDrawerContent.displayName = 'DrawerContent'

const BarSoftDrawerHeader = ({className, ...props}) => <div className={cn('grid gap-1.5 p-4 text-center sm:text-left', className)} {...props} />
BarSoftDrawerHeader.displayName = 'DrawerHeader'

const BarSoftDrawerFooter = ({className, ...props}) => <div className={cn('mt-auto flex flex-col gap-2 p-4 pt-1', className)} {...props} />
BarSoftDrawerFooter.displayName = 'DrawerFooter'

const BarSoftDrawerTitle = React.forwardRef(({className, ...props}, ref) => <DrawerPrimitive.Title ref={ref} className={cn('text-lg font-semibold leading-none tracking-tight', className)} {...props} />)
BarSoftDrawerTitle.displayName = DrawerPrimitive.Title.displayName

const BarSoftDrawerDescription = React.forwardRef(({className, ...props}, ref) => <DrawerPrimitive.Description ref={ref} className={cn('text-sm text-foreground/70', className)} {...props} />)
BarSoftDrawerDescription.displayName = DrawerPrimitive.Description.displayName

export {BarSoftDrawer, BarSoftDrawerPortal, NestedDrawer, BarSoftDrawerOverlay, BarSoftDrawerTrigger, BarSoftDrawerClose, BarSoftDrawerContent, BarSoftDrawerHeader, BarSoftDrawerFooter, BarSoftDrawerTitle, BarSoftDrawerDescription}
